module.exports = __webpack_public_path__ + "09c6b44d21b2cf2bf54ee5519231e637.pdf";